import { routes } from '~/components/app/appMainRoutes';
import { enrichmentRoutes } from '~/components/HubspotEnrichment/constants';
import { settingsRoutes } from '~/components/settings/settingsRoutes';

import { useHomeIntegrations } from '../hooks/useHomeIntegrations';
import { OnboardingChecklist } from './OnboardingChecklist';
import { OnboardingItem, OnboardingItemDivider } from './OnboardingItem';

export const ListEnrichment = () => {
  const { isHubSpotConnected } = useHomeIntegrations();
  const hasCompanyEnrichment = false;
  const hasContactEnrichment = false;
  const hasEnrichmentMappings = false;

  return (
    <OnboardingChecklist title="Get started with Enrichment">
      <OnboardingItem
        isComplete={isHubSpotConnected}
        number={1}
        title="Connect to HubSpot"
        to={settingsRoutes.hubSpotIntegration}
      />
      <OnboardingItemDivider />
      <OnboardingItem
        isComplete={hasEnrichmentMappings}
        isDisabled={!isHubSpotConnected}
        number={2}
        title="Set up enrichment mappings"
        to={enrichmentRoutes.mappingCompanies}
      />
      <OnboardingItemDivider />
      <OnboardingItem
        isComplete={hasCompanyEnrichment}
        isDisabled={!isHubSpotConnected}
        number={3}
        title="Enable company enrichment"
        to={routes.enrichment}
      />
      <OnboardingItemDivider />
      <OnboardingItem
        isComplete={hasContactEnrichment}
        isDisabled={!isHubSpotConnected}
        number={4}
        title="Enable contact enrichment"
        to={routes.enrichment}
      />
    </OnboardingChecklist>
  );
};
